import { Config } from '../_config'
import { FactoryCookie } from '../_cookie/FactoryCookie'
import { Environment } from '../_kernel/Environment'
import { BaseFetcher } from './BaseFetcher'
import { Fetcher } from './Fetcher'

export class FactoryFetcher {
  static create({ config }: { config: Config }) {
    return new FactoryFetcher(config)
  }

  constructor(private config: Config) {}

  async fetcher(): Promise<Fetcher> {
    const isNode = Environment.create().isNode()

    const token = await this.getAuthToken()

    return isNode
      ? (await import('./NodeFetcher')).NodeFetcher.create({ config: this.config, token })
      : (await import('./WindowFetcher')).WindowFetcher.create({ config: this.config, token })
  }

  private async getAuthToken(): Promise<string | undefined> {
    const cookie = await FactoryCookie.create({ config: this.config }).cookie()
    const [, token] = cookie.get<string>({
      key: BaseFetcher.AUTH_COOKIE_NAME,
    })

    return token
  }
}
